export const messages = {
  fastFacts: "Fast Facts",
};
